module.exports = __webpack_public_path__ + "img/nosotros_16-9_1440.b9cc8ae2.webp";